// extracted by mini-css-extract-plugin
export var contianer = "heading1-module--contianer--P6DE3";
export var text = "heading1-module--text--o9HTC";